import { buildFullURL, addDomainToPath } from '~/utils/url';
import { mapGetters } from 'vuex';

export default {
    head() {
        // const fullURL = buildFullURL(this.$nuxt.context);
        const head = {
            title: this.seo?.title ? this.seo?.title : process.env.PUBLIC_URL,
            meta: [
                // {
                //     hid: 'og:url',
                //     property: 'og:url',
                //     content: fullURL
                // },
                // {
                //     hid: 'og:type',
                //     property: 'og:type',
                //     content: 'website'
                // },
                // {
                //     hid: 'og:image',
                //     property: 'og:image',
                //     content: this.globalSettings?.siteLogo
                // }
            ]
        };
        if (this.seo?.description) {
            head.meta.push({
                hid: 'description',
                name: 'description',
                content: this.seo.description
            });
            head.meta.push({
                hid: 'og:description',
                property: 'og:description',
                content: this.seo.description
            });
        }
        if (this.seo?.title) {
            head.meta.push({
                hid: 'og:title',
                property: 'og:title',
                content: this.seo.title
            });
        }

        if (this.seo?.keywords) {
            head.meta.push({
                hid: 'keywords',
                name: 'keywords',
                content: this.seo.keywords
            });
        }
        // if (this.seo?.img) {
        head.meta.push({
            hid: 'image',
            name: 'image',
            content: this.seo.img || this.defaultImage
        });
        head.meta.push({
            hid: 'og:image',
            property: 'og:image',
            content: this.seo.img || this.defaultImage
        });
        // }
        if (this.breadcrumbs?.length) {
            const jsonld = {
                '@context': 'https://schema.org',
                '@type': 'BreadcrumbList',
                itemListElement: this.breadcrumbs.map((item, index) => {
                    return {
                        '@type': 'ListItem',
                        position: index + 1,
                        name: item.title,
                        item: addDomainToPath(this.$nuxt.localePath(item.route))
                    };
                })
            };
            head.script = [
                {
                    type: 'application/ld+json',
                    json: jsonld
                }
            ];
        }

        return head;
    },

    computed: {
        ...mapGetters({
            globalSettings: 'global/globalSettings',
            getCurrentTheme: 'global/getCurrentTheme'
        }),
        defaultImage() {
            if (this.getCurrentTheme === 'light-theme') {
                return this.globalSettings.logo?.logoLight;
            }
            return this.globalSettings.logo?.logoDark;
        }
    }
};
